/** `management\query::searchIcons` rows: the Font Awesome label and its `fas fa-*` class. */
import * as z from 'zod/mini';
import type { IconRow } from '../types';
import type { WireSchema } from '../wire';

export const iconRows = z.array(z.looseObject({ name: z.string(), class: z.string() })) as unknown as WireSchema<IconRow[]>;
